import createEmotion from 'create-emotion';
export var emotionInstance = createEmotion({
  key: 'ui-kit-css'
});